import React from 'react';
import ImageTable from './ImageTable';

const Office = () => {
  return (
    <div className="text-dark w-full flex flex-col justify-center items-center">
      <div className="w-full h-full overflow-hidden flex justify-center items-center">
        <img
          src="static/resources/Cabinet1.jpg"
          className=" min-w-[1000px] w-full min-h-[200px]"
          alt="Description"
        />
        <div className="px-8 sm:p-0 text-light text-lg md:text-xl lg:text-2xl absolute max-w-xl flex flex-col justify-center items-center">
          <p className="text-2xl md:text-3xl lg:text-4xl">Cabinet</p>
        </div>
      </div>
      <div className=" flex justify-center items-center">
        <div className="flex flex-col text-left mt-14 mb-14 text-sm lg:text-lg overflow-auto max-w-3xl px-8 py-8 sm:py-16">
          <p>
            Poziționat în zona centrală, ușor accesibilă, oferă liniște,
            curățenie și intimitate.
          </p>

          <p className="mt-6">
            Activitate de lucru individuală cu fiecare copil.
          </p>
          <p className="mt-6">
            Dotat cu mobilier adaptat copiilor de orice vârstă, oglinda
            logopedică, materiale și jucării specifice, de calitate.
          </p>
          <p className="mt-6">
            Colaborare cu specialiști din alte domenii adiacente (psihologi,
            psihoterapeuți, medici pediatri și neuro-pediatri, ortodonți,
            stomatologi, psihiatri, profesori, învățători, educatori,
            specialiști în alăptare).
          </p>
        </div>
      </div>
      <ImageTable />
    </div>
  );
};

export default Office;
